module.exports = __webpack_public_path__ + "img/vehicle-connections.8502c8eb.png";